import React from "react";
import { chain } from "lodash";
import moment from "moment";
import { useMutation } from "react-query";
import { Button, Divider, Form, Row, Col, message } from "antd";
import { Loader } from "semantic-ui-react";
import { useHistory, Link } from "react-router-dom";
import { CreateEmployeeForms } from "./Forms/EmployeeCreateForm";
import { AxiosEmployeeAPI } from "../../Api";
import { EmployeeScreenContainer } from "../../../styled-component/EmployeeScreenContainer";
import { useDelayedEmployeeFormSearchReducer } from "./hooks";
import { useFetchEmployeeFormData } from "../../hooks";
import { useSettingValue } from "../../../utils/Hooks";
import { createEmployeeErrorLogs } from "../../utils";
import { Trans } from "common/components/MockedTrans.tsx";

const useTranslation = () => {
  return { t: (text) => text };
};

export const EmployeeCreateScreen = () => {
  const { t } = useTranslation();

  const [form] = Form.useForm();

  const history = useHistory();
  const isIntegrationAuthEnabled = useSettingValue("INTEGRATION_AUTH_ENABLED");

  const [searchState, dispatch] = useDelayedEmployeeFormSearchReducer();
  const { data: formData, isLoading } = useFetchEmployeeFormData(searchState);

  const mutation = useMutation(
    ["createCompleteEmployee"],
    AxiosEmployeeAPI.createCompleteEmployee,
    {
      onError: (err) => createEmployeeErrorLogs(err),
      onSuccess: () => onSuccess(),
    },
  );

  const onSuccess = () => {
    form.resetFields();
    message.success(t("Funcionário criado com sucesso!"));
    history.push("/funcionarios");
  };

  const createEmployee = (values) => {
    const payload = {
      ...values,
      systems_permissions: chain(values.systems_permissions)
        .pickBy()
        .keys()
        .value(),
      start_date: moment(values.start_date).format("YYYY-MM-DD"),
    };

    if (values.birth_date) {
      payload.birth_date = moment(values.birth_date).format("YYYY-MM-DD");
    }
    mutation.mutate(payload);
  };

  if (isLoading) return <Loader active />;

  return (
    <EmployeeScreenContainer>
      <CreateEmployeeForms
        form={form}
        onFinish={createEmployee}
        isIntegrationAuthEnabled={isIntegrationAuthEnabled}
        dispatch={dispatch}
        formData={formData}
      />
      <Divider style={{ borderTop: "2px solid rgba(0, 0, 0, 0.06)" }} />
      <Row justify="end">
        <Col>
          <Link to="/funcionarios">
            <Button
              type="ghost"
              onClick={() => {
                form.resetFields();
              }}
            >
              Cancelar
            </Button>
          </Link>
        </Col>
        <Col offset={1}>
          <Button
            type="primary"
            loading={mutation.isLoading}
            onClick={() => {
              form
                .validateFields()
                .then((values) => {
                  createEmployee(values);
                })
                .catch(() =>
                  message.error(
                    t("Por favor preencha todos campos obrigatórios"),
                  ),
                );
            }}
          >
            <Trans>Salvar</Trans>
          </Button>
        </Col>
      </Row>
    </EmployeeScreenContainer>
  );
};
